export default "__VITE_ASSET__QY4EJ89Y__"